export const vulnerabilityMessages = {
  fr: {
    BSS: "Banque de données du sous-sol",
    IGN: "Carte IGN au 1/25 000ème",
    geoportal: "Géoportail",
    AEP: "Captages AEP et protection",
    ADES: "Info terre",
    SIE: "Eaux france",
    NORTH: "Nord",
    NORTH_EAST: "Nord-Est",
    EAST: "Est",
    SOUTH_EAST: "Sud-Est",
    SOUTH: "Sud",
    SOUTH_WEST: "Sud-Ouest",
    WEST: "Ouest",
    NORTH_WEST: "Nord-Ouest",
    BSS_NUMBER: "N° BSS",
    SITE_DISTANCE: "Distance site (m)",
    POSITION: "Position",
    GEOLOGICAL_FORMATIONS: "Formations Géologiques",
    TOP_LAYER: "Haut de couche",
    BOTTOM_LAYER: "Bas de couche",
    NATURE: "Nature",
    LOW: "Faible",
    MEDIUM: "Moyenne",
    HIGH: "Forte",
    SHALLOW_WATER_TABLE: "Nappe peu profonde",
    DEEP_WATER_TABLE: "Nappe très profonde",
    PRESENCE_IMPERMEABLE_LAYER: "Présence d'une couche imperméable",
    PRESENCE_PERMEABLE_LAYER: "Présence d'une couche perméable",
    RUNOFF_PRESENT_ON_SITE: "Présence de ruissellement sur site",
    UPSTREAM: "Amont",
    DOWNSTREAM: "Aval",
    LATERAL: "Latéral",
    UNKNOWN: "Ne sait pas",
    REFERENCE: "Référence",
    USAGE: "Usage",
    NAME: "Nom",
    SENSITIVE_USAGE: "Usage sensible",
    SURVEILLANCE_EQUIPMENT: "Ouvrage surveillance",
    DISTANCE: "Distance au site (m)",
    DISTANCE_KM: "Distance au site (km)",
    HYDRAULIC_POSITION: "Positionnement hydraulique supposé",
    ZNIEFF_I: "ZNIEFF de type I",
    ZNIEFF_II: "ZNIEFF de type II",
    NATURA_2000: "Natura 2000",
    PROXIMITY_IMMEDIATE: "Proximité immédiate",
    DISTANCE_1: "Eloignement",
    ABSENCE_DIRECT_TRANSFER_LANE: "Absence voies transfert direct",
    errorHandleSave: "Une erreur est survenue",
    successHandleSave: "Informations de vulnérabilité enregistrées avec succès",
    AEP_USAGE: "AEP",
    GEOTHERMAL: "Géothermie",
    INDUSTRIAL_WATER: "Eau industrielle",
    DOMESTIC_WATER: "Eau domestique",
    SURVEILLANCE: "Surveillance",
    WATERING: "Abreuvage",
    IRRIGATION: "Irrigation",
    WATER_DEPTH: "Profondeur d'eau (m)",
  },

  en: {
    BSS: "Subsoil database",
    IGN: "IGN map at 1/25 000th",
    geoportal: "Geoportal",
    AEP: "Data on AEP catchments and protection perimeters of the Regional Health Agency",
    ADES: "The ADES database",
    SIE: "Water Information System",
    NORTH: "North",
    NORTH_EAST: "North-East",
    EAST: "East",
    SOUTH_EAST: "South-East",
    SOUTH: "South",
    SOUTH_WEST: "South-West",
    WEST: "West",
    NORTH_WEST: "North-West",
    BSS_NUMBER: "BSS number",
    SITE_DISTANCE: "Site distance (m)",
    POSITION: "Position",
    GEOLOGICAL_FORMATIONS: "Geological Formations",
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
    SHALLOW_WATER_TABLE: "Shallow water table",
    DEEP_WATER_TABLE: "Very deep water table",
    PRESENCE_IMPERMEABLE_LAYER: "Presence of an impermeable layer",
    PRESENCE_PERMEABLE_LAYER: "Presence of a permeable layer",
    RUNOFF_PRESENT_ON_SITE: "Runoff present on the site",
    UPSTREAM: "Upstream",
    DOWNSTREAM: "Downstream",
    LATERAL: "Lateral",
    UNKNOWN: "Unknown",
    PROXIMITY_IMMEDIATE: "Immediate proximity",
    DISTANCE_1: "Distance",
    ABSENCE_DIRECT_TRANSFER_LANE: "Absence of direct transfer lanes",
    REFERENCE: "Reference",
    USAGE: "Usage",
    NAME: "Name",
    SENSITIVE_USAGE: "Sensitive usage",
    SURVEILLANCE_EQUIPMENT: "Surveillance equipment",
    DISTANCE: "Distance(m)",
    DISTANCE_KM: "Distance(km)",
    HYDRAULIC_POSITION: "Supposed hydraulic positioning",
    ZNIEFF_I: "ZNIEFF type I",
    ZNIEFF_II: "ZNIEFF type II",
    NATURA_2000: "Natura 2000",
    errorHandleSave: "An error occurred",
    successHandleSave: "Vulnerability information saved successfully",
    AEP_USAGE: "AEP",
    GEOTHERMAL: "Geothermal",
    INDUSTRIAL_WATER: "Industrial water",
    DOMESTIC_WATER: "Domestic water",
    SURVEILLANCE: "Surveillance",
    WATERING: "Watering",
    IRRIGATION: "Irrigation",
    WATER_DEPTH: "Water depth (m)",
  },
};
